import Maze from "../maze/Maze.js";
import TileMap from "./tilemap/TileMap.js";
import Game from "../Game.js";
import AutoWalkthrough from "./AutoWalkthrough.js";
import Hero from "./mobs/Hero.js";
import Control from "./controllers/Control.js";
import MazeRenderDebug from "../maze/MazeRenderDebug.js";
import Slime from "./mobs/Slime.js";
import Column from "./mobs/Column.js";
import Door from "./mobs/Door.js";
import BasicAI from "./mobs/ai/BasicAI.js";
import PlayerControl from "./controllers/PlayerControl.js";
import Pqp from "../../3x1010/Pqp.js";
import Orc from "./mobs/Orc.js";
import TileWindow from "../utils/tileWindow/TileWindow.js";
import Paperdoll from "./containers/paperdoll/Paperdoll.js";
import Inventory from "./containers/inventory/Inventory.js";
import Status from "./status/Status.js";
import Actions from "./actions/Actions.js";
import Chest from "./mobs/Chest.js";
import ChestContent from "./containers/chestcontent/ChestContent.js";
import Bout from "../bout/Bout.js";
import DungeonMaster from "../bout/DungeonMaster.js";
import ItemSlot from "./itemSlot/ItemSlot.js";
import Skills from "./skills/Skills.js";
import ItemInfo from "./itemInfo/ItemInfo.js";
import Helper from "../utils/helper/Helper.js";
import ItemProviders from "../items/ItemProviders.js";
import Comparer from "../items/Comparer.js";
import Fight from "./fight/Fight.js";
import Lore from "./fight/Lore.js";
import MobInfo from "./mobInfo/MobInfo.js";
import Goblin from "./mobs/Goblin.js";
import Sniper from "./mobs/Sniper.js";
import Troll from "./mobs/Troll.js";
import Bat from "./mobs/Bat.js";
import Rat from "./mobs/Rat.js";
import Spider from "./mobs/Spider.js";
import Fireplace from "./mobs/Fireplace.js";
import RoomDresser from "./roomDresser/RoomDresser.js";
import Player from "../bout/Player.js";
import Stats from "./stats/Stats.js";

export default class Screen {
	constructor(sprites, callback) {
		this.tileMap = null;
		this.model = null;
		this.sprites = sprites;
		this.callback = callback;
		this.hero = null;
		this.enemies = null;
		this.ais = null;
		this.featurer = null;
		this.winMap = null;
		this.winInventory = null;
		this.winPaperdoll = null;
		this.winStatus = null;
		this.winActions = null;
		this.paused = false;
		this.winChests = new Array();
		this.winItemInfos = new Array();
		this.winMobInfos = new Array();
		this.canDrag = false;
		this.roomSecretChecked = new Array();
		Screen.that = this;
		jQuery(".js-disabler").show();
	}

	init(model, featurer) {
		Bout.that.resetLeveChests();
		MobInfo.checkTactics = new Array();
		this.model = model;
		this.featurer = featurer;
		this.roomDresser = new RoomDresser(model, Bout.that.cfg, this.sprites);
		this.createWindowMap();
		this.createWindowInventory();
		this.createWindowPaperdoll();
		this.createWindowStatus();
		this.createWindowActions();
		this.arrangeWindows();
		jQuery(window).on("resize.screen", this.arrangeWindows.bind(this));
	}

	createWindowMap() {
		//this.winMap = new TileWindow(jQuery(".js-screen-tilemap"), Game.AREA_GAME_ROWS + 1, Game.AREA_GAME_COLS, this.sprites, false, false, "map");
		let det = this.featurer.getCurrentLevelDetails();
		this.winMap = new TileWindow(jQuery(".js-screen-tilemap"), 16, 15, this.sprites, false, false, "map");
		this.winMap.init(det.name + " - Level " + (parseInt(det.level) + 1));

		TileMap.STYLER = this.model.styler;


		//let clip = jQuery("#template-tilemap").clone();
		//clip.attr("id", "tilm" + Screen.ENUM++)

		this.tileMap = new TileMap(this.model, Game.AREA_GAME_ROWS, Game.AREA_GAME_COLS, this.sprites, this.tileMapEventsHandler.bind(this));
		this.tileMap.init();
		this.winMap.addContent(this.tileMap.getClip(), this.tileMap)


	}

	createWindowInventory() {
		this.winInventory = new TileWindow(jQuery(".js-screen-tilemap"), 6, 8, this.sprites, true, false, "inventory");
		this.winInventory.init("Inventory");
		this.inventory = new Inventory(this.moveItemsEventsHandler.bind(this));
		this.inventory.init();
		this.winInventory.addContent(this.inventory.getClip(), this.inventory);

		let a = Bout.that.getInventory();
		for (let x = 0; x < a.length; x++) {
			this.inventory.addItem(a[x], a[x].containerPos);
		}

	}

	createWindowPaperdoll() {
		this.winPaperdoll = new TileWindow(jQuery(".js-screen-tilemap"), 11, 8, this.sprites, true, false, "paperdoll");
		this.winPaperdoll.init("Paperdoll");
		this.paperdoll = new Paperdoll(this.moveItemsEventsHandler.bind(this));
		this.paperdoll.init();
		this.winPaperdoll.addContent(this.paperdoll.getClip(), this.paperdoll);
		let a = Bout.that.getPaperdoll();
		for (let x = 0; x < a.length; x++) {
			this.paperdoll.addItem(a[x], a[x].containerPos);
		}


	}


	createWindowStatus() {
		this.winStatus = new TileWindow(jQuery(".js-screen-tilemap"), 9, 8, this.sprites, true, false, "status");
		this.winStatus.init("Status");
		this.status = new Status(this.paperdoll, this.statusEventsHandler.bind(this));
		this.status.init();
		this.winStatus.addContent(this.status.getClip(), this.status);

	}
	createWindowActions() {
		this.winActions = new TileWindow(jQuery(".js-screen-tilemap"), 4, 8, this.sprites, true, false, "actions");
		this.winActions.init("Maze Hero!");
		this.actions = new Actions(this.actionsEventHandler.bind(this));
		this.actions.init();
		this.winActions.addContent(this.actions.getClip(), this.actions);

	}

	statusEventsHandler(e) {
		if (e.type === Status.EVENT_OPEN_SKILLS) {
			this.createWindowSkills();
		}
	}

	createWindowSkills() {
		if (this.winSkills) {
			return
		}
		this.winSkills = new TileWindow(jQuery(".js-screen-tilemap"), 16, 12, this.sprites, true, true, "skills", this.skilsEventsHandler.bind(this));
		this.winSkills.init("Skills");
		this.skills = new Skills();
		this.skills.init();
		this.winSkills.addContent(this.skills.getClip(), this.skills);
		this.arrangeWinSkill();

	}

	skilsEventsHandler(e) {
		if (e.type === TileWindow.EVENT_CLOSE) {
			this.winSkills.destroy();
			this.winSkills = null;
		}

	}


	actionsEventHandler(e) {
		//console.log(e)
		if (e.type == Actions.EVENT_CLICKED) {
			if (e.data.which === Actions.REARRANGE) {
				this.arrangeWindows();
			}
			if (e.data.which === Actions.PAUSE) {
				this.pause();
			}
			if (e.data.which === Actions.PLAY) {
				this.resume();
			}
			if (e.data.which === Actions.INFO) {
				this.openStats();
			}
			if (e.data.which === Actions.SHARE) {
				Helper.alert("Sorry", "This feature has not yet been implemented!", null, 1);
			}
			if (e.data.which === Actions.SETTINGS) {
				Helper.alert("Sorry", "This feature has not yet been implemented!", null, 1);
			}
			if (e.data.which === Actions.EXIT) {
				let det = this.featurer.getCurrentLevelDetails();
				console.log(det.level)
				if (parseInt(det.level) === 0) {
					Helper.alert("Quit", "Do you really want to quit?", this.quitFeedback.bind(this), 2);
				} else {
					Helper.alert("Quit", "Do you really want to quit? (the game was saved at the last level you reached)", this.quitFeedback.bind(this), 2);
				}

			}

		}
	}

	quitFeedback(lFlag) {
		if (lFlag) {
			document.location.href = "https://www.3x1010.it";
		}
	}

	pause() {
		this.paused = true;
		for (let x = 0; x < this.tileMap.mobs.length; x++) {
			let mob = this.tileMap.mobs[x];
			if (mob.isInView()) {
				if (mob.clas !== "door") {
					//console.log(mob.clas)
					mob.pauseAnimation()
				}
				//console.log(mob)
			}
		}
		for (let x = 0; x < this.model.torches.length; x++) {
			let torch = this.model.torches[x];
			if (torch.isInView()) {
				torch.activateTilesAnimations(false);
			}
		}
		for (let x = 0; x < this.model.spikes.length; x++) {
			let spike = this.model.spikes[x];
			if (spike.isInView()) {
				spike.activateTilesAnimations(false);

			}
		}
		this.playerControl.enable(false);


	}
	resume() {
		this.paused = false;
		for (let x = 0; x < this.tileMap.mobs.length; x++) {
			let mob = this.tileMap.mobs[x];
			if (mob.isInView()) {
				if (mob.clas !== "door") {
					mob.resumeAnimation()
				}
				//console.log(mob)
			}
		}
		for (let x = 0; x < this.model.torches.length; x++) {
			let torch = this.model.torches[x];
			if (torch.isInView()) {
				torch.activateTilesAnimations(true);
			}
		}
		for (let x = 0; x < this.model.spikes.length; x++) {
			let spike = this.model.spikes[x];
			if (spike.isInView()) {
				spike.activateTilesAnimations(true);
			}
		}

		this.playerControl.enable(true);

	}


	mazeEventsHandler(e) {

		let msg = null;
		if (e.type === Maze.EVENT_CREATING_ROOM) {
			msg = "Room creation: " + (e.data.iterations + 1);
		}
		if (e.type === Maze.EVENT_CHECKING_ROOM) {
			msg = "Room structure: " + (e.data.iterations + 1);
		}
		if (e.type === Maze.EVENT_CHECK_FOR_UNREACHABLE_ROOMS) {
			msg = "Unreachable rooms: " + (e.data.iterations + 1);
		}
		if (e.type === Maze.EVENT_CREATE_PATH_BLOCK) {
			msg = "Paths, nodes: " + (e.data.lasts);
		}
		if (e.type === Maze.EVENT_PATH_CREATED) {
			msg = "Paths created!";
		}
		if (e.type === Maze.EVENT_FIXING_ROOM_WALLS) {
			msg = "Walling up rooms: " + Math.floor((e.data.iterations + 1) / e.data.rows * 100) + "%";
		}
		if (e.type === Maze.EVENT_MOVE_ROOM_DOORS) {
			msg = "Moving rooms' doors: " + Math.floor((e.data.iterations + 1) / e.data.rows * 100);
		}
		if (e.type === Maze.EVENT_SETTING_UNREACHABLE_CELLS_AS_WALL) {
			msg = "Walling up maze: " + Math.floor((e.data.iterations + 1) / e.data.rows * 100) + "%";
		}
		if (e.type === Maze.EVENT_LOOKING_FOR_ROOM_DOORS) {
			msg = "Rooms' doors: " + Math.floor((e.data.iterations + 1) / e.data.rows * 100) + "%";
		}
		if (e.type === Maze.EVENT_DIJKSTRA) {
			msg = "Dijkstra, nodes: " + (e.data.lasts);
		}
		if (e.type === Maze.EVENT_DIJKSTRA_COMPLETED) {
			msg = "Dijkstra completed!";
		}
		if (e.type === Maze.EVENT_FINDING_PATH) {
			msg = "Walkthrough, nodes: " + (e.data.lasts);
		}
		if (e.type === Maze.EVENT_PATH_FOUND) {
			msg = "Walkthrough done!";
		}
		if (e.type === Maze.EVENT_LOOKING_FOR_DEAD_ENDS) {
			msg = "Dead ends: " + Math.floor((e.data.iterations + 1) / e.data.rows * 100) + "%";
		}
		if (e.type === Maze.EVENT_COMPUTING_POI) {
			msg = "Computing POI: " + Math.floor((e.data.count) / e.data.total * 100) + "%";
		}
		if (e.type === Maze.EVENT_NEED_REBUILD) {
			this.dispatch({ type: Screen.EVENT_REBUILD_MAZE });
		}
		if (msg) {
			this.tileMap.setLoadingMessage(msg);
		}
		if (e.type === Maze.EVENT_MAZE_READY) {
			this.dispatch({ type: Screen.EVENT_MODEL_READY });
		}


	}

	tileMapEventsHandler(e) {
		if (e.type === TileMap.EVENT_REACHED_EXIT) {
			this.dispatch({ type: Screen.EVENT_LEVEL_COMPLETED });
		}
		if (e.type === TileMap.EVENT_MOVE_N) {
			this.playerControl.n = -1;
		}
		if (e.type === TileMap.EVENT_MOVE_S) {
			this.playerControl.s = 1;
		}
		if (e.type === TileMap.EVENT_MOVE_E) {
			this.playerControl.e = 1;
		}
		if (e.type === TileMap.EVENT_MOVE_W) {
			this.playerControl.w = -1;
		}

		if (e.type === TileMap.EVENT_MOVE_STOP) {
			this.playerControl.stop();
			this.playerControl.enable(true);
		}
		if (e.type === TileMap.EVENT_EXITED) {
			this.tileMap.levelCompleted();
		}
		if (e.type === TileMap.EVENT_ENTERED) {
			this.actions.enable(Actions.PAUSE, true);
			this.canDrag = true;
			if (!Bout.gv("welcomeMessage")) {
				this.actions.trigger(Actions.PAUSE);
				Helper.alert("Welcome!", "Do your best to escape the Honeywood's maze ("+Game.LABEL_LEVELS+" levels).<br>It will be not an easy task!", this.activateGameAfterWelcome.bind(this), 1);
				Bout.sv("welcomeMessage", true);
			}
			Bout.incStatistic(Bout.STAT_SECRETS_TOTAL, this.model.initer.secretRooms);
			jQuery(".js-disabler").hide();
			//console.log(this.model.initer.secretRooms)



		}
		if (e.type === TileMap.EVENT_EXITING) {
			this.playerControl.stop();
			this.playerControl.enable(false);
			this.actions.enable(Actions.PAUSE, false);
			this.canDrag = false;
			jQuery(".js-disabler").show();
		}
		if (e.type === TileMap.EVENT_PAUSE_GAME) {
			this.actions.trigger(Actions.PAUSE)
		}
		if (e.type === TileMap.EVENT_OPEN_CHEST) {
			this.actions.trigger(Actions.PAUSE);
			this.openChest(e.data.chest);
		}
		if (e.type === TileMap.EVENT_CLOSE_CHEST) {
			this.closeChest(e.data.chest);
		}
		if (e.type === TileMap.EVENT_START_FIGHT) {
			this.actions.trigger(Actions.PAUSE);
			this.startFight(e.data.mob);
		}
		if (e.type === TileMap.EVENT_GAME_OVER) {
			this.actions.trigger(Actions.PAUSE);
			Helper.alert("What a defeat!", "Do you want to restart this level?", this.heroDefeatedFeedback.bind(this))
		}


	}

	activateGameAfterWelcome() {
		this.actions.trigger(Actions.PLAY);
	}
	dispatch(e) {
		if (this.callback) {
			this.callback.call(null, e);
		}
	}

	build() {
		// 
		this.tileMap.initMap();
		this.placeChests();
		this.dressRooms();
		this.createStatics();
		
		//this.createEnemies();
		let ret = Bout.that.dm.createEnemiesForThisLevel(this.tileMap, this.sprites);
		this.enemies = ret[0];
		this.ais = ret[1];

		this.createHero();
		this.addFurnitures();

		this.createPlayerControl();
		this.tileMap.attachCamera(this.hero);
		this.dispatch({ type: Screen.EVENT_SCREEN_READY });
		this.save();

	}

	createStatics() {
		let a = this.model.statics;
		let doors = new Array();
		let chestIndex = 0;
		for (let x = 0; x < a.length; x++) {
			if (a[x].type === Maze.STATIC_TYPE_COLUMN) {
				let column = new Column(this.sprites, a[x].cell.column, this.tileMap.sp.style);
				column.init();
				this.tileMap.addMob(column, a[x].cell);
			}
			if (a[x].type === Maze.STATIC_TYPE_CHEST) {
				let chest = new Chest(this.sprites, a[x].cell, 0, chestIndex);
				chestIndex++;
				chest.init();
				this.tileMap.addMob(chest, a[x].cell);
			}
			if (a[x].type === Maze.STATIC_TYPE_FIREPLACE) {
				let fireplace = new Fireplace(this.sprites, a[x].cell);
				fireplace.init();
				this.tileMap.addMob(fireplace, a[x].cell);
			}
			if (a[x].type === Maze.STATIC_TYPE_DOOR) {
				let cell = a[x].cell;
				let door;
				if (doors.indexOf(cell.id) < 0) {
					if (cell.isDoor) {
						if (cell.isHorizontalDoor()) {
							door = new Door(this.sprites, Door.TYPE_DOOR, this.tileMap.sp.style, true, cell);
						} else {
							door = new Door(this.sprites, Door.TYPE_SPIKE, this.tileMap.sp.style, false, cell);
						}
					}
					if (cell.isSecretExit()) {
						if (cell.isHorizontalSecretExit()) {
							door = new Door(this.sprites, Door.TYPE_SECRET, this.tileMap.sp.style, true, cell);
						} else {
							door = new Door(this.sprites, Door.TYPE_SECRET, this.tileMap.sp.style, false, cell);
						}
					}
					if (door) {
						door.init();
						this.tileMap.addMob(door, a[x].cell);
						doors.push(a[x].cell.id)
					}
				}
			}
		}
	}

	createHero() {
		this.hero = new Hero(this.sprites);
		this.hero.init();
		let where = this.model.getWhatBorderTheCellBelongsTo(this.model.startCell)
		let deltaX = 0;
		let deltaY = 0;
		if (where === Maze.DIR_N) {
			//deltaX = 4;
			//deltaY = 3;
		} else if (where === Maze.DIR_S) {
			//deltaX = 4;
		} else if (where === Maze.DIR_E) {
			//deltaY = 4;
		} else if (where === Maze.DIR_W) {
			//deltaY = 4;
		}
		//deltaX = 0;
		//deltaY = 0;
		//console.log(deltaY, deltaX)
		this.tileMap.addMob(this.hero, this.model.startCell, deltaX, deltaY);
	}
	/*
	createEnemies() {
		console.log("TO DO - Create enemies on level")
		this.enemies = new Array();
		this.ais = new Array();
		for (let x = 0; x < this.model.rooms.length; x++) {
			//for (let x = 0; x < 2; x++) {

			let enemy;
			if (Pqp.rnd(1) === 0) {
				enemy = new Spider(this.sprites);
			} else {
				enemy = new Spider(this.sprites);
			}
			let ai = this.createAI();
			enemy.init();
			ai.attachTo(enemy);
			ai.init();
			this.ais.push(ai);
			this.enemies.push(enemy);
			this.tileMap.addMob(enemy, this.model.rooms[x].getFreeCellNearCenterCell());
		}
	}
	*/
	/*	createAI() {
			let ai = new BasicAI(this.model, this.tileMap);
			return ai;
		}*/

	createPlayerControl() {
		this.playerControl = new PlayerControl(this.playerControlEventsHandler.bind(this))
		this.playerControl.init();
		this.playerControl.attachTo(this.hero);
	}

	playerControlEventsHandler(e) {
		if (e.type === Control.EVENT_CHANGED_STATUS) {
			e.data.mob.setAnimation(e.data.status);
		}
		if (e.type === Control.EVENT_MOVE) {
			//this.tileMap.moveMobTo(e.data.mob, e.data.x * Game.WALK_STEP, e.data.y * Game.WALK_STEP);
			this.tileMap.moveMobTo(e.data.mob, e.data.x, e.data.y);
		}
		if (e.type === Control.EVENT_FIRED) {
			this.tileMap.checkPlayerInteractions();
		}

	}

	mainLoop() {
		if (this.paused) {
			return;
		}
		this.tileMap.mainLoop();
		this.status.update();
		if (this.winSkills) {
			this.skills.update(this.paperdoll);
		}
		if (this.winStats) {
			if (this.stats) {
				this.stats.update();
			}
		}
		this.consumeWaterAndFood();
		this.checkIfHeroInSecretRoom();

	}

	checkIfHeroInSecretRoom() {
		if (this.hero.cell.isRoom()) {
			let room = this.model.getRoomById(this.hero.cell.room)
			if (room.isSecret()) {
				if (this.roomSecretChecked.indexOf(room.id) < 0) {
					this.roomSecretChecked.push(room.id);
					Bout.incStatistic(Bout.STAT_SECRETS_DISCOVERED, 1);
					Bout.incStatistic(Bout.STAT_SCORE, Game.SCORE_SECRET_DISCOVERED);
				}
			}
		}
	}



	levelCompleted() {
		this.closeAllInfoItemWindows();
		this.closeAllInfoMobWindows();
		this.closeAllChests();
		if (this.winSkills) {
			this.winSkills.closeWindow();
		}
		if (this.winStats) {
			this.winStats.closeWindow();
		}
		this.playerControl.enable(false);
		this.doEndLevelAnimation();
		if (this.drag) {
			this.drag.remove();
		}
	}

	doEndLevelAnimation() {
		setTimeout(this.nextLevel.bind(this), 1000);
	}

	nextLevel() {
		this.dispatch({ type: Screen.EVENT_GO_NEXT_LEVEL });
	}

	destroy() {
		this.winMap.destroy();
		this.tileMap.destroy();

		this.winInventory.destroy();
		this.inventory.destroy();
		this.winPaperdoll.destroy();
		this.paperdoll.destroy();
		this.winStatus.destroy();
		this.status.destroy();
		this.winActions.destroy();
		this.actions.destroy();
		if (this.winFight) {
			this.winFight.destroy();
		}

		jQuery(window).off("resize.screen");
	}

	initAis() {
		for (let x = 0; x < this.ais.length; x++) {
			this.ais[x].think();
		}
	}

	arrangeWindows() {
		/*this.winInventory = null;
		this.winPaperdoll = null;
		this.winPaperdoll = null;
		this.winStatus = null;
		this.winActions = null;*/

		// Al centro quella principale
		let w = jQuery(window).width();
		let h = jQuery(window).height();

		this.winMap.css({
			left: Math.floor((w - this.winMap.width()) / 2),
			top: Math.floor((h - this.winMap.height()) / 2)
		})

		this.winPaperdoll.css({
			left: this.winMap.position().left - this.winPaperdoll.width() - Game.TILE_WIDTH,
			top: this.winMap.css("top")
		})

		this.winInventory.css({
			left: this.winMap.position().left + this.winMap.width() + Game.TILE_WIDTH,
			top: this.winMap.css("top")
		})
		this.winStatus.css({
			left: this.winMap.position().left + this.winMap.width() + Game.TILE_WIDTH,
			top: this.winInventory.position().top + this.winInventory.height() + Game.TILE_HEIGHT
		})
		this.winActions.css({
			left: this.winMap.position().left - this.winPaperdoll.width() - Game.TILE_WIDTH,
			top: this.winPaperdoll.position().top + this.winPaperdoll.height() + Game.TILE_HEIGHT
		})

		this.arrangeWinSkill();
		this.arrangeWinStats();

		if (this.winFight) {
			this.winFight.css({
				left: Math.floor((w - this.winMap.width()) / 2),
				top: Math.floor((h - this.winMap.height()) / 2)
			})

		}

		// Chiude tutte le altre
		this.closeAllChests();
		this.closeAllInfoItemWindows();
		this.closeAllInfoMobWindows();

	}

	closeAllInfoMobWindows() {
		for (let x = 0; x < this.winMobInfos.length; x++) {
			this.winMobInfos[x].win.destroy()
		}
		this.winMobInfos = new Array();
	}
	closeAllInfoItemWindows() {
		for (let x = 0; x < this.winItemInfos.length; x++) {
			this.winItemInfos[x].win.destroy()
		}
		this.winItemInfos = new Array();
	}

	closeAllChests() {
		for (let x = 0; x < this.winChests.length; x++) {
			//console.log(this.winChests[x])
			if (this.winChests[x].chest) {
				this.posWinChest(this.winChests[x].win, this.winChests[x].chest);
			} else {
				this.posWinLoot(this.winChests[x].win);
			}
		}
	}


	closeInfoMobWindows(mob) {
		//debugger
		let tmp = new Array();
		for (let x = 0; x < this.winMobInfos.length; x++) {
			if (this.winMobInfos[x].mob.id === mob.id) {
				this.winMonInfos[x].win.destroy();
			} else {
				tmp.push(this.winMobInfos[x]);
			}
		}
		this.winMobInfos = tmp;
	}

	closeInfoItemWindows(itemSlot) {
		//debugger
		if (!itemSlot.getItem()) {
			return
		}
		let tmp = new Array();
		for (let x = 0; x < this.winItemInfos.length; x++) {
			if (this.winItemInfos[x].item.id === itemSlot.getItem().id) {
				this.winItemInfos[x].win.destroy();
			} else {
				tmp.push(this.winItemInfos[x]);
			}
		}
		this.winItemInfos = tmp;
	}

	arrangeWinSkill() {
		if (this.winSkills) {
			this.winSkills.css({
				left: this.winStatus.position().left + this.winStatus.width() + Game.TILE_WIDTH,
				top: this.winMap.position().top
			})

			let e = { x: this.winSkills.position().left, y: this.winSkills.position().top };
			//console.log(e)
			this.winSkills.offestx = 0;
			this.winSkills.offesty = 0;
			this.winSkills.putDrag(e);

		}
	}
	arrangeWinStats() {
		if (this.winStats) {
			this.winStats.css({
				left: this.winPaperdoll.position().left - this.winStats.width() - Game.TILE_WIDTH,
				top: this.winMap.position().top
			})

			let e = { x: this.winStats.position().left, y: this.winStats.position().top };
			//console.log(e)
			this.winStats.offestx = 0;
			this.winStats.offesty = 0;
			this.winStats.putDrag(e);

		}
	}


	placeChests() {
		DungeonMaster.that.placeChests(this.model);
		/*		for (let x = 0; x < this.model.rooms.length; x++) {
					let cell = this.model.rooms[x].getFreeCellUpperRow();
					//console.log(cell)
					if (cell) {
						this.model.statics.push({ type: Maze.STATIC_TYPE_CHEST, cell: cell })
					}
				}*/
	}

	openChest(chest) {
		chest.open();

		let winChest = new TileWindow(jQuery(".js-screen-tilemap"), 4, 8, this.sprites, true, true, "actions", this.chestEventsHandler.bind(this, chest));
		winChest.init("Chest");

		this.posWinChest(winChest, chest);

		let chestContent = new ChestContent(this.moveItemsEventsHandler.bind(this), chest.id);
		chestContent.init();
		winChest.addContent(chestContent.getClip(), chestContent);

		this.winChests.push({ win: winChest, chest: chest, chestContent: chestContent });

		let a = Bout.that.getChestItems(chest.id, false, chest.chestIndex);
		for (let x = 0; x < a.length; x++) {
			chestContent.addItem(a[x], a[x].containerPos);
		}

	}


	posWinChest(winChest, chest) {
		let tile = chest.cell.tiles[0];
		//let p = { x: tile.position().left, y: tile.position().top };
		let posy = tile.offset().top - winChest.height() - Game.TILE_HEIGHT / 2;
		let posx = (tile.offset().left) + Math.floor(Game.TILE_WIDTH - winChest.width() / 2) - Game.TILE_WIDTH / 2;
		if (posy < 0) {
			posy = 0;
		}
		winChest.css({
			top: posy,
			left: posx
		})
	}

	closeChest(chest) {
		let tmp = new Array();
		for (let x = 0; x < this.winChests.length; x++) {
			if (this.winChests[x].chest.id == chest.id) {
				this.winChests[x].win.destroy();
				this.winChests[x].chestContent.destroy();
				//console.log("AAAAAAAAAAAAAAAssssssssssss")
			} else {
				tmp.push(this.winChests[x]);
			}
		}
		this.winChests = tmp;
	}

	chestEventsHandler(chest, e) {
		if (e.type === TileWindow.EVENT_CLOSE) {
			let tmp = new Array();
			for (let x = 0; x < this.winChests.length; x++) {
				if (this.winChests[x].win.id == e.target.id) {
					if (chest) {
						chest.close();
					}
					this.winChests[x].win.destroy();
					this.winChests[x].chestContent.destroy();
					//console.log(this.winChests[x]);
				} else {
					tmp.push(this.winChests[x]);
				}
			}

			this.winChests = tmp;
			if (this.winChests.length === 0) {
				if (chest) {
					// non è un loot
					this.actions.trigger(Actions.PLAY);
				}
			}
			if (!chest) {
				// è un loot
				this.closeFight();
			}

		}

	}

	moveItemsEventsHandler(e) {
		if (e.type === ItemSlot.EVENT_START_PRESS) {
			this.checkWhatToDrag(e);
		}
		if (e.type === ItemSlot.EVENT_ITEM_INFO) {
			this.showItemInfo(e);
		}
		if (e.type === ChestContent.EVENT_TAKE_ALL) {
			//console.log("TAKE ALL!")
			this.takeAllItemsInChest(e.data);
		}
	}

	checkWhatToDrag(e) {
		let itemSlot = e.data.itemSlot;
		let item = itemSlot.getItem();
		this.dragMode = Screen.DRAG_NORMAL;

		if (item.isStackable()) {
			if (item.getStackQuantity() > 1) {
				if (e.data.mouseEvent.shiftKey) {
					this.dragMode = Screen.DRAG_WITH_QUANTITY;
				}
			}
		}
		this.startDrag(e);
	}


	startDrag(e) {
		// Clona
		if (!this.canDrag) {
			return;
		}
		this.closeInfoItemWindows(e.data.itemSlot);
		this.canDrag = false;
		this.checkAutoScrollInventory = false;
		let itemSlot = e.data.itemSlot;
		this.itemSlotDragged = itemSlot;

		//PCL
		let total
		let remains
		if (this.dragMode === Screen.DRAG_WITH_QUANTITY) {
			total = itemSlot.getItem().getStackQuantity();
			let half = Math.floor(total / 2);
			remains = total - half;
			this.quantityDragged = half;
			// Trick per lasciare il numero giusto
			itemSlot.getItem().addStackQuantity(-remains);
			itemSlot.updateQuantity();
		}

		//console.log(e)
		this.winSlotDragged = e.data.from.tileWindow;
		let mc = itemSlot.mc.clone();
		mc.attr("id", "drag" + Screen.ENUM++);
		let pos = [itemSlot.mc.offset().top, itemSlot.mc.offset().left];
		mc.css({ top: pos[0], left: pos[1] });
		jQuery(".js-screen-tilemap").append(mc);
		jQuery(".js-empty", mc).hide();
		jQuery(".js-rarity", mc).hide();
		jQuery(".js-over", mc).hide();
		if (this.dragMode !== Screen.DRAG_WITH_QUANTITY) {
			jQuery(".js-filled", itemSlot.mc).hide();
			jQuery(".js-rarity", itemSlot.mc).hide();
		}
		jQuery(".js-cantplace", mc).css("background-image", "url('./assets/ui/cantplace.png')");
		jQuery(".js-cantplace", mc).hide();

		if (this.dragMode === Screen.DRAG_WITH_QUANTITY) {
			itemSlot.getItem().setStackQuantity(remains);
			itemSlot.updateQuantity();
		}

		this.drag = mc;
		this.drag.addClass("dragging");

		// Listener e offset
		//this.prevent(e)
		this.prevent(e.data.mouseEvent)
		if (Pqp.isMobile()) {
			jQuery(window).on("touchend", this.stopPress.bind(this));
			jQuery(window).on("touchmove", this.moveTouch.bind(this));
		} else {
			jQuery(window).on("mouseup", this.stopPress.bind(this));
			jQuery(window).on("mousemove", this.moveTouch.bind(this));
		}
		var mouse = this.getMousePosition(e.data.mouseEvent);
		var tmp = jQuery.globalToLocal(this.drag, mouse.x, mouse.y);
		this.offestx = tmp.x;
		this.offesty = tmp.y;

		this.moveTouch(e.data.mouseEvent)
	}

	prevent(e) {
		if (this.mobile) {
			e.preventDefault();
		}
	}

	getMousePosition(e) {
		var o = new Object();
		if (Pqp.isMobile()) {
			o.x = e.originalEvent.touches[0].pageX;
			o.y = e.originalEvent.touches[0].pageY;
		} else {
			e = e || window.event; // IE-ism
			o.x = e.clientX;
			o.y = e.clientY;
		}
		return o;
	}

	moveTouch(e) {
		jQuery(".js-over", jQuery(".js-screen-tilemap")).hide();
		var mouse = this.getMousePosition(e);
		this.lastMousePosition = mouse
		this.putDrag(this.lastMousePosition)
		// Controlla su che area si trova
		let toCheck = [this.winInventory, this.winPaperdoll];
		for (let x = 0; x < this.winChests.length; x++) {
			toCheck.push(this.winChests[x].win);
		}
		this.winTargetted = null;
		this.itemSlotTargetted = null;
		jQuery(".js-cantplace", this.drag).hide();

		for (let x = 0; x < toCheck.length; x++) {
			if (this.hitTest(this.drag, toCheck[x])) {
				this.winTargetted = toCheck[x];
				this.checkHitSlots(toCheck[x]);
			}
		}
		if (this.winTargetted) {
			if (this.winTargetted.clipContentClass.typeContainer === "inventory") {
				//console.log(this.winTargetted.clipContent)
				if (!this.checkAutoScrollInventory) {
					this.checkAutoScrollInventory = true;
					this.setAutoScrollInventory();
				}
			}
		} else {
			this.checkAutoScrollInventory = false;
			clearTimeout(this.idAutoScrolInventory);
		}


	}

	setAutoScrollInventory() {
		let mouse = this.lastMousePosition;
		let area = jQuery(".js-slots", this.winTargetted.clipContent);
		let curScroll = area.scrollTop()
		if (mouse.y > area.offset().top + area.height()) {
			curScroll += 4;
			area.scrollTop(curScroll)
		}
		if (mouse.y < area.offset().top) {
			curScroll -= 4;
			area.scrollTop(curScroll)
		}
		this.idAutoScrolInventory = setTimeout(this.setAutoScrollInventory.bind(this), 20);
	}


	putDrag(e) {
		var newPosx = e.x;
		var newPosy = e.y;
		this.drag.css({ left: newPosx - this.offestx, top: newPosy - this.offesty });

	}

	stopPress() {
		clearTimeout(this.idAutoScrolInventory);
		this.checkWhereReleased();
		jQuery(window).off("touchend");
		jQuery(window).off("touchmove");
		jQuery(window).off("mouseup");
		jQuery(window).off("mousemove");
	}

	hitTest(ela, elb) {
		let rectA = { x: ela.offset().left, y: ela.offset().top, w: ela.width(), h: ela.height() };
		let rectB = { x: elb.offset().left, y: elb.offset().top, w: elb.width(), h: elb.height() };
		return this.hitTestRect(rectA, rectB);
	}

	hitTestRect(rectA, rectB) {

		var rA = rectA.x + rectA.w; // Right side of rectA
		var rB = rectB.x + rectB.w; // Right side of rectB
		var bA = rectA.y + rectA.h; // Bottom of rectA
		var bB = rectB.y + rectB.h; // Bottom of rectB

		var hitX = rA > rectB.x && rectA.x < rB; // True if hit on x-axis
		var hitY = bA > rectB.y && rectA.y < bB; // True if hit on y-axis

		// Return true if hit on x and y axis
		return hitX && hitY;
	}

	checkHitSlots(win) {
		let slots = win.clipContentClass.getItemsSlots();
		let tests = new Array();
		for (let x = 0; x < slots.length; x++) {
			// Cicla le slots
			let itemSlot = slots[x];
			// Controlla se la slot è visibile (potrebbe essere scrollata)
			if (this.isSlotVisible(itemSlot)) {
				// Controlla se c'è un hit test
				if (this.hitTest(itemSlot.mc, this.drag)) {
					tests.push(itemSlot);
				}
			}
		}
		// Tra tutti gli hittest prende quella in cui il drag è più dentro
		if (tests.length > 0) {
			this.itemSlotTargetted = this.getSlotDragBelongsMore(tests)
			jQuery(".js-over", this.itemSlotTargetted.mc).show();
			//this.itemSlotTargetted = itemSlot;
			// Controlla se è compatibile
			if (this.checkDestinationSlot(this.itemSlotTargetted)) {
				// Controlla se la destinazione è occupata e se è compatibile per lo swap
				let itemSwap = this.itemSlotTargetted.getItem();
				if (itemSwap) {
					this.checkSourceSlot(itemSwap)
				}
			}
		}

	}


	getSlotDragBelongsMore(slots) {
		// Ritorna la slot in cui il drag è "più presente" (la sua area occupa uno spazio maggiore)
		let max = -10000000;
		let drag = this.drag;
		let slot = null;
		for (let x = 0; x < slots.length; x++) {

			let a = [
				//mob.mc.position().left,
				//mob.mc.position().left + mob.width,
				drag.position().left,
				drag.position().left + drag.width(),
				slots[x].mc.offset().left,
				slots[x].mc.offset().left + slots[x].mc.width()
			];
			let b = [
				//mob.mc.position().top,
				//mob.mc.position().top + mob.height,
				drag.position().top,
				drag.position().top + drag.height(),
				slots[x].mc.offset().top,
				slots[x].mc.offset().top + slots[x].mc.height()
			];
			a.sort(function (a, b) {
				return a - b;
			});
			b.sort(function (a, b) {
				return a - b;
			});
			let p0 = { x: a[1], y: b[1] };
			let p1 = { x: a[2], y: b[2] };
			let area = Math.abs((p1.x - p0.x) * (p1.y - p0.y));
			if (area > max) {
				max = area;
				slot = slots[x];
			}
		}
		return slot;
	}



	checkSourceSlot(itemSwap) {
		if (!this.itemSlotDragged.isCompatible(itemSwap)) {
			jQuery(".js-cantplace", this.drag).show();
			return false;
		}
		return true
	}

	checkDestinationSlot(itemSlot) {
		// Deve essere compatibile
		if (!itemSlot.isCompatible(this.itemSlotDragged.item)) {
			jQuery(".js-cantplace", this.drag).show();
			return false;
		}
		// Se si dragga una quantità la cella di destinazione deve essere vuota o dello stesso tipo
		if (this.dragMode === Screen.DRAG_WITH_QUANTITY) {
			if (itemSlot.hasItem()) {
				if (itemSlot.getItem().template_id !== this.itemSlotDragged.getItem().template_id) {
					jQuery(".js-cantplace", this.drag).show();
					return false;
				}
			}
		}

		// Controlla il peso finale se si sta draggando nell'inventario
		if (!this.checkInventoryWeight()) {
			jQuery(".js-cantplace", this.drag).show();
			return false;
		}

		// Controlla se si possiedono i requisiti qualora si stesse draggando un item sulla paperdoll
		if (!this.checkRequirementForItemWorn()) {
			jQuery(".js-cantplace", this.drag).show();
			return false;
		}

		return true
	}
	checkRequirementForItemWorn() {
		if (this.winTargetted.clipContentClass.typeContainer === "paperdoll") {
			let item = this.itemSlotDragged.item;
			return this.checkRequirementForItem(item);
		}
		return true
	}

	checkRequirementForItem(item) {
		let player = Bout.that.player;
		if (item.level > player.currentLevel) {
			return false;
		}

		// Weapon
		if (item.skill_needed > 0) {
			let value = player.getSkillValue(item.weapon_skill)
			if (value < item.skill_needed) {
				return false;
			}
		}
		// Armour 
		if (item.armour_class !== ItemProviders.ARMOUR_CLASS_NONE) {
			let skl = player.getSkillValue("ArmourProficiency");
			if (skl < item.getMinimumSkillNeededForArmour()) {
				return false;
			}
		}
		return true;
	}


	checkInventoryWeight() {
		// Controlla il peso finale se si sta draggando nell'inventario
		if (this.winTargetted.clipContentClass.typeContainer === "inventory") {
			let w = this.winTargetted.clipContentClass.getWeight();
			let max = this.winTargetted.clipContentClass.getMaxWeight();
			let witem = this.itemSlotDragged.item.getWeight();
			let itemdest = this.itemSlotTargetted.getItem();
			let wtoremove = 0;
			if (itemdest) {
				wtoremove = itemdest.getWeight();
				if (itemdest.isStackable() && (itemdest.template_id === this.itemSlotDragged.item.template_id)) {
					// il wtoremove si azzera
					wtoremove = 0;
				}
			}
			let witemdragged = 0;
			if (this.winSlotDragged.clipContentClass.typeContainer === "inventory") {
				// Se la finestra di partenza è l'inventario stesso deve rimuovere il peso dell'oggetto che si sta draggando
				witemdragged = witem;
			}
			//console.log(w, witem, wtoremove, witemdragged ,max)
			if (w + witem - wtoremove - witemdragged > max) {
				return false;
			}
		}

		return true
	}


	checkWhereReleased() {
		jQuery(".js-over", jQuery(".js-screen-tilemap")).hide();
		if (this.itemSlotTargetted) {
			// Controlla se il target è l'inventario e se pesa troppo
			if (!this.checkInventoryWeight()) {
				jQuery(".js-cantplace", this.drag).hide();
				this.goBackToHomeSlot();
				return
			}
			// Controlla se può indossare l'arma o l'armatura o altro
			if (!this.checkRequirementForItemWorn()) {
				jQuery(".js-cantplace", this.drag).hide();
				this.goBackToHomeSlot();
				return
			}
			if (!this.itemSlotTargetted.isCompatible(this.itemSlotDragged.item)) {
				// back home
				jQuery(".js-cantplace", this.drag).hide();
				this.goBackToHomeSlot();
			} else {
				if (this.dragMode === Screen.DRAG_WITH_QUANTITY) {
					if (this.itemSlotTargetted.hasItem()) {
						if (this.itemSlotTargetted.getItem().template_id !== this.itemSlotDragged.getItem().template_id) {
							jQuery(".js-cantplace", this.drag).hide();
							this.goBackToHomeSlot();
							return;
						}
					}
					this.putItemInSlot();
				} else {
					// Controlla se c'è uno swap e l'item risulta incompatibile con il source slot
					let itemSwap = this.itemSlotTargetted.getItem();
					if ((itemSwap) && (!this.itemSlotDragged.isCompatible(itemSwap))) {
						this.goBackToHomeSlot();
					} else {
						this.putItemInSlot();

					}
				}
			}

		} else {
			// back home
			this.goBackToHomeSlot();
		}

	}

	putItemInSlot() {
		TweenMax.to(this.drag, 0.1, { left: this.itemSlotTargetted.mc.offset().left, top: this.itemSlotTargetted.mc.offset().top, onComplete: this.itemPutInPlace.bind(this) });
	}

	itemPutInPlace() {
		// Prende l'item
		let item = this.itemSlotDragged.item;
		this.closeInfoItemWindows(this.itemSlotTargetted);
		// Lo toglie dal contenitore presente nella finestra da cui arriva e distrugge il drag (solo se non sta draggando una quantity)
		if (this.dragMode !== Screen.DRAG_WITH_QUANTITY) {
			this.winSlotDragged.clipContentClass.removeItem(item)
		}
		this.drag.remove();
		jQuery(".js-filled", this.itemSlotDragged.mc).show();
		// Lo aggiunge nel contenitore presente nella finestra targettata
		let itemInPlace
		if (this.dragMode !== Screen.DRAG_WITH_QUANTITY) {
			itemInPlace = this.winTargetted.clipContentClass.addItem(item, this.itemSlotTargetted.id);
		} else {
			// La cella è vuota oppure c'è un altro item dello stesso tipo
			// crea al volo un nuovo item da aggiungere
			let newItemSameTemplate = Bout.that.createItemFromTemplate(this.itemSlotDragged.getItem().template_id);
			newItemSameTemplate.setStackQuantity(this.quantityDragged);
			itemInPlace = this.winTargetted.clipContentClass.addItem(newItemSameTemplate, this.itemSlotTargetted.id);
			item = newItemSameTemplate;
		}
		if (!itemInPlace) {
			this.canDrag = true;
			this.updateBout();
		} else {
			// Controlla se è uno stackable dello stesso template_id
			//console.log(itemInPlace,item)
			if (itemInPlace.isStackable() && (itemInPlace.getTemplate() == item.getTemplate())) {
				item.addStackQuantity(itemInPlace.getStackQuantity());
				this.itemSlotTargetted.updateQuantity();
				this.canDrag = true;
				this.inventory.updateWeight();
				this.updateBout();
			} else {
				//console.log(this.itemSlotTargetted)
				//console.log(this.itemSlotDragged)
				//this.closeInfoItemWindows(this.itemSlotDragged);
				//debugger
				// Controlla se è uno swap
				let mc = this.itemSlotTargetted.mc.clone();
				mc.attr("id", "drag" + Screen.ENUM++);
				let pos = [this.itemSlotTargetted.mc.offset().top, this.itemSlotTargetted.mc.offset().left];
				mc.css({ top: pos[0], left: pos[1] });
				let sprite = this.sprites.getSprite("items", itemInPlace.rownew, itemInPlace.colnew);
				if (sprite) {
					jQuery(".js-filled", mc).css("background-image", "url('" + sprite + "')");
				}
				jQuery(".js-screen-tilemap").append(mc);
				jQuery(".js-empty", mc).hide();
				jQuery(".js-rarity", mc).hide();
				jQuery(".js-over", mc).hide();
				jQuery(".js-cantplace", mc).hide();
				mc.addClass("dragging");

				let left = this.itemSlotDragged.mc.offset().left;
				let top = this.itemSlotDragged.mc.offset().top;
				if (!this.isSlotVisible(this.itemSlotDragged)) {
					TweenMax.to(mc, this.getBackHomeTime(mc) / 2, { opacity: 0 });
				}


				//TweenMax.to(mc, this.getBackHomeTime(mc), { left: this.itemSlotDragged.mc.offset().left, top: this.itemSlotDragged.mc.offset().top, onComplete: this.itemSwapped.bind(this, itemInPlace, mc) });
				TweenMax.to(mc, this.getBackHomeTime(mc), { left: left, top: top, onComplete: this.itemSwapped.bind(this, itemInPlace, mc) });


			}
		}



	}



	itemSwapped(itemInPlace, mc) {
		this.winSlotDragged.clipContentClass.addItem(itemInPlace, this.itemSlotDragged.id);
		this.canDrag = true;
		this.updateBout();
		mc.remove();
		jQuery(".js-filled", this.itemSlotDragged.mc).show();
		jQuery(".js-rarity", this.itemSlotDragged.mc).show();
	}


	goBackToHomeSlot() {
		let left = this.itemSlotDragged.mc.offset().left;
		let top = this.itemSlotDragged.mc.offset().top;
		if (!this.isSlotVisible(this.itemSlotDragged)) {
			TweenMax.to(this.drag, this.getBackHomeTime(this.drag) / 2, { opacity: 0 });
		}

		TweenMax.to(this.drag, this.getBackHomeTime(this.drag), { left: left, top: top, onComplete: this.itemBackedHome.bind(this) });
	}

	getDistance(xA, yA, xB, yB) {
		var xDiff = xA - xB;
		var yDiff = yA - yB;

		return Math.sqrt(xDiff * xDiff + yDiff * yDiff);
	}


	getBackHomeTime(mc) {
		let dist = this.getDistance(mc.position().left, mc.position().top, this.itemSlotDragged.mc.offset().left, this.itemSlotDragged.mc.offset().top)
		let time = Math.floor(dist / 100) * 0.025 + 0.1;
		return time;
	}

	getTimeBasedOnDistanceBetweenSlots(slot0, slot1) {
		let dist = this.getDistance(slot0.mc.offset().left, slot0.mc.offset().top, slot1.mc.offset().left, slot1.mc.offset().top)
		let time = Math.floor(dist / 100) * 0.025 + 0.1;
		return time;
	}


	itemBackedHome() {
		this.canDrag = true;
		this.drag.remove();
		this.updateBout();
		if (this.dragMode === Screen.DRAG_WITH_QUANTITY) {
			let total = this.itemSlotDragged.getItem().getStackQuantity() + this.quantityDragged;
			//console.log(this.itemSlotDragged.getItem().getStackQuantity())
			//console.log(this.quantityDragged)
			// Trick per lasciare il numero giusto
			this.itemSlotDragged.getItem().setStackQuantity(total);
			this.itemSlotDragged.updateQuantity();

		} else {
			jQuery(".js-filled", this.itemSlotDragged.mc).show();
			jQuery(".js-rarity", this.itemSlotDragged.mc).show();
		}
	}

	isSlotVisible(itemSlot) {
		// Controlla che non sia nella parte di overflow
		let cont = itemSlot.mc.parent();
		if (this.hitTest(cont, itemSlot.mc)) {
			return true;
		}
		return false;

	}

	updateBout() {
		Bout.that.updateInventory(this.inventory);
		Bout.that.updatePaperdoll(this.paperdoll);
		for (let x = 0; x < this.winChests.length; x++) {
			Bout.that.updateLevelChest(this.winChests[x].chestContent);
		}
		this.updateCompare();

		// Controlla la consistenza della paperdoll
		this.checkPaperdollConsistency()

	}

	save() {
		this.saveAtBeginnigOfLevel = this.model.saveStruct(this.tileMap, this.featurer);
	}


	checkPaperdollConsistency() {
		let slots = this.paperdoll.getItemsSlots();
		let toRemove = new Array();
		for (let x = 0; x < slots.length; x++) {
			if (slots[x].hasItem()) {
				let item = slots[x].getItem();
				if (!this.checkRequirementForItem(item)) {
					toRemove.push({ item: item, itemSlot: slots[x] });
				}
			}
		}

		for (let x = 0; x < toRemove.length; x++) {
			// Senza tante animazioni tanto è un caso limite
			let o = toRemove[x];
			this.paperdoll.removeItem(o.item);
			this.inventory.addItem(o.item, -1);
		}


	}


	takeAllItemsInChest(chestContent) {
		if (!this.canDrag) {
			return;
		}
		//this.closeAllInfoItemWindows();
		this.canDrag = false;

		let a = chestContent.getItemsSlots()

		let none = true;
		let toPut = []
		for (let x = 0; x < a.length; x++) {
			let itemToAdd = a[x].getItem();
			if (itemToAdd) {
				none = false;
				toPut.push(a[x]);
			}
		}

		if (none) {
			this.canDrag = true;
		} else {
			this.toTakeAll = toPut;
			this.indexTakeAll = 0;
			this.putNextItemInInventory(chestContent)
		}

	}

	putNextItemInInventory(chestContent) {
		if (this.indexTakeAll < this.toTakeAll.length) {
			this.putNextItem(this.toTakeAll[this.indexTakeAll], chestContent);
			this.indexTakeAll++;
		} else {
			this.canDrag = true;
			chestContent.tileWindow.closeWindow();
		}
	}

	putNextItem(slotSource, chestContent) {
		let itemToAdd = slotSource.getItem();
		let targetSlotItem = null;
		this.closeInfoItemWindows(slotSource);

		// Controlla se aggiungendo l'item si sta sotto il peso
		let w = this.inventory.getWeight();
		let max = this.inventory.getMaxWeight();
		let witem = itemToAdd.getWeight();
		//console.log(w, witem, max)
		if (w + witem > max) {
			itemToAdd = null;
		}

		if (itemToAdd) {
			//let slotSource = a[x]
			if (itemToAdd.isStackable()) {
				targetSlotItem = this.inventory.findSlotItemSameTemplate(itemToAdd.template_id);
			}

			if (!targetSlotItem) {
				targetSlotItem = this.inventory.findFirstEmptySlotItem();
			}

			if (targetSlotItem) {
				let destPos;
				if ((this.isSlotVisible(targetSlotItem)) && (!itemToAdd.isCoin())) {
					// targetta quella
					destPos = { top: targetSlotItem.mc.offset().top, left: targetSlotItem.mc.offset().left };
				} else {
					if (itemToAdd.isCoin()) {
						// Targetta più o meno dove ci sono i soldi
						let trg = this.winInventory.offset()
						trg.top = trg.top + this.winInventory.height() - targetSlotItem.mc.height();
						trg.left = trg.left + this.winInventory.width() - targetSlotItem.mc.width();
						destPos = { top: trg.top, left: trg.left };

					} else {
						// Targetta genericamente metà inventario
						let trg = this.winInventory.clipContent.offset()
						let delta = (this.winInventory.clipContent.height() - targetSlotItem.mc.height()) / 2;
						trg.top = trg.top + delta;
						trg.left = trg.left;
						destPos = { top: trg.top, left: trg.left };
					}
				}

				let mc = slotSource.mc.clone();
				mc.attr("id", "drag" + Screen.ENUM++);
				let pos = [slotSource.mc.offset().top, slotSource.mc.offset().left];
				mc.css({ top: pos[0], left: pos[1] });
				jQuery(".js-screen-tilemap").append(mc);
				jQuery(".js-empty", mc).hide();
				jQuery(".js-rarity", mc).hide();
				jQuery(".js-over", mc).hide();
				jQuery(".js-filled", slotSource.mc).hide();
				mc.addClass("dragging");

				TweenMax.to(mc, this.getTimeBasedOnDistanceBetweenSlots(slotSource, targetSlotItem), { top: destPos.top, left: destPos.left, onComplete: this.addToInventoryFromChest.bind(this, chestContent, mc, slotSource, targetSlotItem) });
			} else {
				requestAnimationFrame(this.putNextItemInInventory.bind(this, chestContent));
			}

		} else {
			requestAnimationFrame(this.putNextItemInInventory.bind(this, chestContent));
		}
	}

	addToInventoryFromChest(chestContent, mc, source, target) {
		let itemToAdd = source.getItem();
		let itemInPlace = target.getItem()
		chestContent.removeItem(source.getItem());

		if (itemInPlace && itemInPlace.isStackable() && (itemInPlace.getTemplate() == itemToAdd.getTemplate())) {
			itemInPlace.addStackQuantity(itemToAdd.getStackQuantity());
			target.updateQuantity();
		} else {
			this.inventory.addItem(itemToAdd, target.id);
		}
		this.canDrag = true;
		this.inventory.updateWeight();
		this.updateBout();

		mc.remove();
		jQuery(".js-filled", source.mc).show();
		jQuery(".js-rarity", source.mc).show();
		this.putNextItemInInventory(chestContent);
	}


	showItemInfo(e) {
		let item = e.data.itemSlot.getItem();

		// Controlla se è già aperta
		for (let x = 0; x < this.winItemInfos.length; x++) {
			if (this.winItemInfos[x].item.id === item.id) {
				this.winItemInfos[x].win.setOverAll();
				return;
			}
		}

		let itemInfo = new ItemInfo(e.data.itemSlot, this.itemInfoEventsHandler.bind(this));
		jQuery(".js-screen-tilemap").append(itemInfo.getClip());
		itemInfo.init();
		let h = itemInfo.getHeight()
		let tiles = Math.ceil(h / Game.TILE_HEIGHT) + 1;
		//console.log(tiles);


		let winItemInfo = new TileWindow(jQuery(".js-screen-tilemap"), tiles, 8, this.sprites, true, true, "item" + tiles, this.winItemInfoEventsHandler.bind(this));
		winItemInfo.init(item.getDescType());
		winItemInfo.addContent(itemInfo.getClip(), itemInfo);

		this.winItemInfos.push({ win: winItemInfo, itemInfo: itemInfo, item: item });


		let itemSlotMc = e.data.itemSlot.mc;
		//let p = { x: tile.position().left, y: tile.position().top };
		//let posy = itemSlotMc.offset().top - winItemInfo.height() - itemSlotMc.width() / 4;
		let posy = itemSlotMc.height() + itemSlotMc.offset().top + itemSlotMc.width() / 4;
		let posx = (itemSlotMc.offset().left) + Math.floor(itemSlotMc.width() - winItemInfo.width() / 2) - itemSlotMc.width() / 2;

		winItemInfo.css({
			top: posy,
			left: posx
		})
		let tmp = { x: winItemInfo.position().left, y: winItemInfo.position().top };
		winItemInfo.offestx = 0;
		winItemInfo.offesty = 0;
		winItemInfo.putDrag(tmp);

		this.updateCompare();

	}

	winItemInfoEventsHandler(e) {
		if (e.type === TileWindow.EVENT_CLOSE) {
			let tmp = new Array();
			for (let x = 0; x < this.winItemInfos.length; x++) {
				if (this.winItemInfos[x].win.id == e.target.id) {
					this.winItemInfos[x].win.destroy();
				} else {
					tmp.push(this.winItemInfos[x]);
				}
			}
			this.winItemInfos = tmp;
		}
	}

	itemInfoEventsHandler(e) {
		if (e.type === ItemInfo.EVENT_USE) {
			if (e.cook) {
				this.cookItem(e);
			} else {
				this.consumeItem(e);
			}
		}
		if (e.type === ItemInfo.EVENT_DESTROY) {
			let item = e.data.item;
			if (item.isStackable()) {
				if (item.getStackQuantity() > 1) {
					Helper.alert("Please confirm", "Are you sure you want to destroy one of these item?", this.destroyFeedback.bind(this, e))
					return
				}
			}
			Helper.alert("Please confirm", "Are you sure you want to destroy this item?", this.destroyFeedback.bind(this, e))
		}

	}

	destroyFeedback(e, ris) {
		//console.log(e)
		if (ris) {
			let item = e.data.item;
			if (item.isStackable()) {
				if (item.getStackQuantity() > 1) {
					item.addStackQuantity(-1);
					e.data.itemSlot.updateQuantity();
					let oldPos;
					if (e.data.tileWindow) {
						oldPos = e.data.tileWindow.position();
						e.data.tileWindow.closeWindow();
					}
					this.updateBout();
					if (e.data.tileWindow) {
						e.data.itemSlot.showItemInfo();
						for (let x = 0; x < this.winItemInfos.length; x++) {
							if (this.winItemInfos[x].item.id === item.id) {
								this.winItemInfos[x].win.css({ left: oldPos.left, top: oldPos.top });
							}
						}
					}
					return
				}
			}

			e.data.itemSlot.removeItem(e.data.item);
			if (e.data.tileWindow) {
				e.data.tileWindow.closeWindow();
			}
			this.updateBout();
		}
	}
	consumeItem(e) {
		if (this.winFight) {
			if (e.data.item.isConsumable()) {
				if (e.data.item.heal > 0) {

					this.fight.healHero(e.data.item.heal);

				}
			}
		}

		let item = e.data.item;
		item.use();
		if (this.winFight) {
			this.fight.hero.gotHeal();
		}

		this.destroyFeedback(e, true);
	}

	cookItem(e) {
		if (!Screen.that.heroIsNearLightFireplace()) {
			Helper.alert("Warning!", "You are too far from a fireplace in order to cook this!", null, 1);
			return
		}

		let id = e.data.item.cooktransform;
		this.destroyFeedback(e, true);
		let item = Bout.that.createItemFromTemplate(id)
		Player.checkSkill(Skills.SKILL_COOKING);
		// Controllare la distanza

		// Controlla se l'ha bruciato
		let skill = Bout.that.player.getSkillValue(Skills.SKILL_COOKING);
		let lAdd = false;

		if (skill >= e.data.item.cookskill) {
			lAdd = true;
		} else {
			// Da rivedere è un po' a cazzo
			let dif = 1000 - (e.data.item.cookskill - skill);
			dif = dif / 1000;
			if (Pqp.check(dif)) {
				lAdd = true;
			}
		}

		if (lAdd) {
			this.inventory.addItem(item, -1);
		} else {
			this.tileMap.showMessage("Oh no! You burned the dish!")
		}




	}


	updateCompare() {
		let a = this.winItemInfos;
		for (let x = 0; x < a.length; x++) {
			Comparer.compare(this.paperdoll, a[x]);
		}

	}

	showSkillGain(skill, value, inc, lFight) {
		if (lFight) {
			this.fight.showSkillGain(skill, value, inc);
		} else {
			this.tileMap.showSkillGain(skill, value, inc);
		}

	}

	consumeWaterAndFood() {
		Bout.that.player.consumeWaterAndFood();
	}

	startFight(mob) {
		this.closeAllInfoItemWindows();
		this.closeAllInfoMobWindows();

		this.backBlack = jQuery("#template-back-black").clone();
		this.backBlack.attr("id", "bacbla" + Screen.ENUM++);
		jQuery(".js-screen-tilemap").append(this.backBlack);
		this.backBlack.css("z-index", TileWindow.ZINDEX++);

		this.winFight = new TileWindow(jQuery(".js-screen-tilemap"), 16, 15, this.sprites, true, false, "map", null, true);
		this.winFight.init("Fight!");

		let hero = new Hero(this.sprites);
		hero.init();
		let directions = {
			hero: {
				facing: this.hero.facing,
				top: this.hero.mc.position().top,
				left: this.hero.mc.position().left
			},
			mob: {
				facing: mob.facing,
				top: mob.mc.position().top,
				left: mob.mc.position().left
			}
		}
		this.fight = new Fight(hero, mob, this.generateStackEnemies(mob), directions, this.fightEventsHandler.bind(this));
		this.fight.init();
		this.winFight.addContent(this.fight.getClip(), this.fight)

		let w = jQuery(window).width();
		let h = jQuery(window).height();

		this.winFight.css({
			left: Math.floor((w - this.winFight.width()) / 2),
			top: Math.floor((h - this.winFight.height()) / 2)
		})

		jQuery(".js-window-content", this.winFight.mc).css("z-index", 60);

	}


	fightEventsHandler(e) {
		if (e.type === Fight.EVENT_WON) {
		//	this.hero.setInvulnerable(3000);
			this.removeEnemy();
			//console.log("SUCA1")
		}
		if (e.type === Fight.EVENT_OPEN_LOOT) {
			this.winPaperdoll.bringToTop();
			this.winInventory.bringToTop();
			this.openLoot(e.data.stackIndex);
		}
		if (e.type === Fight.EVENT_USE) {
			this.consumeItem(e);
		}
		if (e.type === Fight.EVENT_HERO_DEFEATED) {
			Helper.alert("What a defeat!", "Do you want to restart this level?", this.heroDefeatedFeedback.bind(this))
		}

	}

	generateStackEnemies(mob) {

		return Bout.that.dm.generateStackEnemies(mob);
		//console.log("TO DO - GENERATE ENEMIES")

		/*if (mob.stack) {
			return mob.stack;
		}*/

		/*		let ret = [];
				ret.push(new Orc(mob.sp, false))
				//ret.push(new Orc(mob.sp, false))
				//ret.push(new Orc(mob.sp, false))
				//ret.push(new Orc(mob.sp, false))
				/*ret.push(new Slime(mob.sp, false))
				ret.push(new Slime(mob.sp, false))
				ret.push(new Slime(mob.sp, false))
				ret.push(new Slime(mob.sp, false))*/
		//ret.push(new Orc(mob.sp, false))
		//ret.push(new Slime(mob.sp, false))
		//ret.push(new Orc(mob.sp))
		/*	for (let x = 0; x < ret.length; x++) {
				ret[x].init(this.sprites)
				Lore.add(ret[x]);
			}
			mob.stack = ret;
	
			return ret;*/

	}


	removeEnemy() {
		this.winFight.destroy();
		this.backBlack.remove();
		this.tileMap.killMob(this.fight.enemy);
		this.actions.trigger(Actions.PLAY);
		this.hero.spiked = false;
		this.hero.setInvulnerable(1000);
		this.hero.controller.enable(true);
		this.hero.setAnimation("idle");
		//console.log("SUCA22")

	}


	openLoot(stackIndex) {
		let fakeId = "idloot" + Screen.ENUM++;
		let winChest = new TileWindow(jQuery(".js-screen-tilemap"), 4, 8, this.sprites, true, true, "actions", this.chestEventsHandler.bind(this, null), true);
		winChest.init("Loot");

		this.posWinLoot(winChest);

		let chestContent = new ChestContent(this.moveItemsEventsHandler.bind(this), fakeId);
		chestContent.init();
		winChest.addContent(chestContent.getClip(), chestContent);

		this.winChests.push({ win: winChest, chest: null, chestContent: chestContent });

		let a = Bout.that.getChestItems(fakeId, true, stackIndex);
		for (let x = 0; x < a.length; x++) {
			chestContent.addItem(a[x], a[x].containerPos);
		}


	}

	posWinLoot(winChest) {
		let ref = this.fight.hero.mc;
		let top = ref.offset().top;
		let left = ref.offset().left + ref.width();
		winChest.css({
			top: top,
			left: left
		})

	}

	closeFight() {
		this.removeEnemy();
	}

	showStackInfo(mob) {
		// Controlla se è già aperta
		for (let x = 0; x < this.winMobInfos.length; x++) {
			if (this.winMobInfos[x].mob.id === mob.id) {
				this.winMobInfos[x].win.setOverAll();
				return;
			}
		}



		let mobInfo = new MobInfo(mob, this.generateStackEnemies(mob));
		jQuery(".js-screen-tilemap").append(mobInfo.getClip());
		mobInfo.init();
		let h = mobInfo.getHeight()
		let tiles = Math.ceil(h / Game.TILE_HEIGHT) + 2;
		//console.log(tiles);


		let winMobInfo = new TileWindow(jQuery(".js-screen-tilemap"), tiles, 8, this.sprites, true, true, "item" + tiles, this.winMobInfoEventsHandler.bind(this));
		winMobInfo.init("Stack Info");
		winMobInfo.addContent(mobInfo.getClip(), mobInfo);

		this.winMobInfos.push({ win: winMobInfo, mobInfo: mobInfo, mob: mob });


		let mobSlotMc = mob.mc;
		//let p = { x: tile.position().left, y: tile.position().top };
		//let posy = itemSlotMc.offset().top - winItemInfo.height() - itemSlotMc.width() / 4;
		let posy = mobSlotMc.height() + mobSlotMc.offset().top + mobSlotMc.width() / 4;
		let posx = (mobSlotMc.offset().left) + Math.floor(mobSlotMc.width() - winMobInfo.width() / 2) - mobSlotMc.width() / 2;

		winMobInfo.css({
			top: posy,
			left: posx
		})
		let tmp = { x: winMobInfo.position().left, y: winMobInfo.position().top };
		winMobInfo.offestx = 0;
		winMobInfo.offesty = 0;
		winMobInfo.putDrag(tmp);

	}

	winMobInfoEventsHandler(e) {
		if (e.type === TileWindow.EVENT_CLOSE) {
			let tmp = new Array();
			for (let x = 0; x < this.winMobInfos.length; x++) {
				if (this.winMobInfos[x].win.id == e.target.id) {
					this.winMobInfos[x].win.destroy();
				} else {
					tmp.push(this.winMobInfos[x]);
				}
			}
			this.winMobInfos = tmp;
		}
	}

	heroDefeatedFeedback(ris) {
		if (ris) {
			if (this.winFight) {
				this.winFight.destroy();
			}
			if (this.backBlack) {
				this.backBlack.remove();
			}
			this.dispatch({ type: Screen.EVENT_RETRY_LEVEL, data: this.saveAtBeginnigOfLevel });
		} else {
			document.location.reload();
		}

	}

	dressRooms() {
		this.roomDresser.dress();
		
	}

	addFurnitures() {
		this.roomDresser.addFurnitures();
	}

	heroIsNearLightFireplace() {
		let cell = this.hero.cell;
		let dirs = [Maze.DIR_NW, Maze.DIR_N, Maze.DIR_NE, Maze.DIR_W, Maze.DIR_E, Maze.DIR_SW, Maze.DIR_S, Maze.DIR_SE];
		for (let x = 0; x < dirs.length; x++) {
			let tmp = this.model.getNearbyCell(cell, dirs[x]);
			if (tmp) {
				if (tmp.isLightFireplace()) {

					return true;
				}
			}
		}
		return false;
	}

	openStats(lEnd=false) {
		this.createWindowStats(lEnd);

	}

	createWindowStats(lEnd = false) {
		if (this.winStats) {
			return
		}
		this.winStats = new TileWindow(jQuery(".js-screen-tilemap"), 16, 12, this.sprites, true, !lEnd, "skills", this.statsEventsHandler.bind(this), lEnd);
		this.winStats.init("Game statistics");
		this.stats = new Stats();
		this.stats.init();
		this.winStats.addContent(this.stats.getClip(), this.stats);
		if (!lEnd) {
			this.arrangeWinStats();
		}

	}

	statsEventsHandler(e) {
		if (e.type === TileWindow.EVENT_CLOSE) {
			this.winStats.destroy();
			this.winStats = null;
		}

	}


}

Screen.ENUM = 0;
Screen.DEBUG_WALKTHROUGH = true;
Screen.EVENT_MODEL_READY = "eventModelReady";
Screen.EVENT_SCREEN_READY = "eventScreenReady";
Screen.EVENT_LEVEL_COMPLETED = "eventLevelCompleted";
Screen.EVENT_GO_NEXT_LEVEL = "eventGoNextLevel";
Screen.EVENT_REBUILD_MAZE = "eventRebuildMaze";
Screen.EVENT_RETRY_LEVEL = "eventRetryLevel";

Screen.DRAG_NORMAL = "dragNormal";
Screen.DRAG_WITH_QUANTITY = "dragWithQuantity";
